import React, {useMemo} from 'react';
import {Menu, MenuItem} from '@mui/material';
import {GridSortModel} from '@mui/x-data-grid';
import {SortDirection} from '../../../types/types';
import {t} from 'i18next';

export interface AurCustomSortProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onSort: (direction: SortDirection) => void;
  sortModel: GridSortModel | undefined;
  activeColumn: string | null;
}

const AurCustomSort: React.FC<AurCustomSortProps> = ({
  anchorEl,
  onClose,
  onSort,
  sortModel,
  activeColumn,
}) => {
  const open = Boolean(anchorEl);

  const setSelectedColumnAndSortOption = useMemo(
    () => (sort: string) =>
      sortModel?.[0]?.sort === sort && sortModel[0]?.field === activeColumn,
    [sortModel, activeColumn]
  );

  const handleSortAscending = () => {
    onSort('asc');
  };

  const handleSortDescending = () => {
    onSort('desc');
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      aria-haspopup="menu"
      aria-expanded={open}
      disableScrollLock
    >
      <MenuItem
        selected={setSelectedColumnAndSortOption('asc')}
        onClick={handleSortAscending}
      >
        {t('sort.ascending')}
      </MenuItem>
      <MenuItem
        selected={setSelectedColumnAndSortOption('desc')}
        onClick={handleSortDescending}
      >
        {t('sort.descending')}
      </MenuItem>
    </Menu>
  );
};

export default AurCustomSort;
